import React from "react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { UserCircle, X } from "@phosphor-icons/react";

/**
 * Shown at the top of the app when the current session is an impersonated one.
 */
export default function ImpersonationBanner() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  if (!user || !user.impersonated_by) return null;

  const end = async () => {
    try {
      await api.post("/auth/end-impersonation");
      await refresh();
      toast.success("Impersonation ended");
      nav("/", { replace: true });
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    }
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="bg-yellow-400 text-black border-b border-black px-6 py-2 flex items-center justify-between"
    >
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest font-bold">
        <UserCircle size={16} weight="bold" />
        Impersonating <span className="font-mono normal-case">{user.email}</span>
        <span className="opacity-70">
          · signed in by {user.impersonator_email}
        </span>
      </div>
      <button
        onClick={end}
        data-testid="end-impersonation-btn"
        className="border border-black bg-white px-3 py-1 text-[11px] uppercase tracking-widest hover:bg-black hover:text-white transition-colors duration-100"
      >
        <X size={10} className="inline mr-1" /> End impersonation
      </button>
    </div>
  );
}
